<template>
  <div class="font-color">
    <v-icon color="black">{{ cssKey == 'background' ? 'mdi-format-color-fill' : 'mdi-format-color-text' }}</v-icon>
    <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" :color="color" class="color-icon">mdi-color-helper</v-icon>
      </template>
      <v-card>
        <v-card-text class="pa-0">
          <v-color-picker @input="debounceUpdate" class="no-alpha" :value="color" flat />
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

import utils from '@/utils/utils'

export default {
  name: 'FontColor',
  props: ['styles', 'cssKey'],
  computed: {},
  data () {
    return {
      color: '#000000',
      menu: false
    }
  },
  created () {
    if (this.styles && this.styles[this.cssKey]) {
      this.color = this.styles[this.cssKey]
    }

    this.debounceUpdate = utils.debounce(($event) => {
      this.color = $event
      const response = {}
      response[this.cssKey] = $event
      this.$emit('update:styles', response)
    }, 400, true)
  },
  methods: {
    reset () {
      this.color = '#000000'
    }
  }
}

</script>

<style lang="sass" scoped>

.font-color
  position: relative
  .color-icon
    position: absolute
    left: 0
    top: 2px

</style>
